/**
 * Remembers the last org/supplier scope the user was viewing so we can send them
 * straight back into the scoped tree instead of the org picker on their next
 * visit. The scoped URL is still the source of truth while inside the app — this
 * is only a hint to rebuild the entry path. Stored as the three path params that
 * make up `/$tenant/$orgId/supplier/{-$supplierId}`.
 */
const LAST_SCOPE_KEY = "admin_last_scope";

export type LastScope = {
  tenant: string;
  orgId: string;
  supplierId?: string;
};

export function rememberLastScope(scope: LastScope) {
  try {
    localStorage.setItem(LAST_SCOPE_KEY, JSON.stringify(scope));
  } catch {
    // Storage full/unavailable — the org picker is a fine fallback.
  }
}

export function readLastScope(): LastScope | null {
  const json = localStorage.getItem(LAST_SCOPE_KEY);
  if (json === null) return null;

  try {
    const scope = JSON.parse(json) as LastScope;
    return scope.tenant && scope.orgId ? scope : null;
  } catch {
    return null;
  }
}

export function clearLastScope() {
  localStorage.removeItem(LAST_SCOPE_KEY);
}
